{
  "ACTIONS": {
    "CONFIRM": "Confirm",
    "CONTINUE": "ادامه",
    "SUBMIT": "Submit",
    "RETRY": "تلاش مجدد",
    "CANCEL": "Cancel",
    "EMPTY": "You have no orders",
    "LOADING_ORDERS": "در حال آماده‌سازی صورت‌حساب شما",
    "CLEAR_ALL": "Clear All",
    "AWESOME": "Awesome!",
    "VIEW_RECEIPT": "The Receipt",
    "ADD_CART": "Add to Cart",
    "UPDATE_CART": "Update Cart",
    "EDIT": "Edit",
    "SEARCH_PLACEHOLDER": "Search for food or restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Some options are missing, please select before proceeding",
    "ITEM_UNAVAILABLE": "This item is currently not available",
    "SECTION_NOT_FOUND": "این بخش دیگر در دسترس نیست",
    "ITEM_NOT_FOUND": "این مورد دیگر موجود نیست",
    "PROMOTION_NOT_AVAILABLE": "این تخفیف ویژه دیگر در دسترس نیست",
    "REQUIRED": "Required",
    "COMBO": "کومبو",
    "INVALID_EMAIL": "لطفاً یک آدرس ایمیل معتبر وارد کنید",
    "INVALID_PHONE": "لطفاً یک شماره تلفن معتبر وارد کنید",
    "FEES": "Fees",
    "MIN_ORDER_ERROR": "Minimum order value of {{currency}} {{amount}} is required to place your order",
    "ADD_MIN_ORDER": "Add {{currency}} {{amount}} to place your order",
    "CONNECTION_ERROR": "هنگام بارگذاری این میز مشکلی پیش آمد. لطفاً دوباره تلاش کنید.",
    "TABLE_NOT_FOUND": "این میز پیدا نشد. لطفاً کد QR را دوباره اسکن کنید."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Last Name",
    "ROOM_NUMBER": "Room Number",
    "SNACKBAR_TITLE": "Your bill is on the way",
    "PAY_BILL": "Pay bill"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "تعداد کل افراد سر میز",
    "PAYING_FOR": "تعداد افرادی که برایشان پرداخت می‌کنید",
    "REMAINING": "مبلغ باقی‌مانده",
    "CHEQUE": "صورت‌حساب",
    "AMOUNT_PAID": "مبلغ پرداخت‌شده",
    "DISCOUNT": "تخفیف",
    "PROMO": "پیشنهاد ویژه",
    "FEES": "هزینه‌های اضافی",
    "PAID_ITEMS": "اقلام پرداخت‌شده",
    "SPLIT_BILL": "تقسیم صورت‌حساب",
    "EDIT_SPLIT": "ویرایش تقسیم",
    "PAY_BILL": "پرداخت صورت‌حساب",
    "SPLIT_TITLE": "تقسیم صورت‌حساب",
    "SPLIT_SUBTITLE": "روش تقسیم صورت‌حساب را انتخاب کنید",
    "SPLIT_EVENLY": "تقسیم مساوی",
    "CUSTOM_AMOUNT": "مبلغ دلخواه",
    "ADD_CUSTOM_AMOUNT": "افزودن مبلغ دلخواه",
    "CUSTOM_AMOUNT_PLACEHOLDER": "مبلغ دلخواه را وارد کنید",
    "PAY_FOR_ITEMS": "پرداخت اقلام خود",
    "CONFIRM_SELECTION": "تأیید انتخاب",
    "SOMEONE_ELSE_PAYING": "شخص دیگری سر میز شما در حال پرداخت است"
  },
  "COMBO": {
    "ADD_N": "افزودن {{count}} {{section}}",
    "REMOVE_N": "حذف {{count}} {{section}}",
    "CANNOT_PROCEED": "لطفاً پیش از ادامه، برای تکمیل کومبو راهنمای بالا را دنبال کنید",
    "COMPLETE": "کومبوی {{combo}} کامل شد!",
    "ON_ANOTHER_SECTION": "این بخشی از کومبوی {{section}} شماست"
  },
  "CART": {
    "TITLE": "Cart",
    "RECOMMENDATION": "You may also like",
    "TOTAL": "Total",
    "VIEW": "View cart & Place order",
    "EMPTY": "Empty",
    "PLACE_ORDER": "Place order",
    "ADD_TO_BILL": "افزودن به صورت‌حساب",
    "PAY_NOW": "اکنون پرداخت کنید",
    "OOPS": "Oops",
    "ADD_NEW_VARIANT": "افزودن مورد دیگر",
    "VARIANT_TITLE": "نظرتان عوض شد؟",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Are you sure you want to clear the cart?",
    "CLEAR": "Clear Cart",
    "ADD_NOTE": "ADD A NOTE",
    "NOTE_LABEL": "Note"
  },
  "PAYMENT": {
    "CONFIRMED": "Your order has been paid !",
    "ERROR": "An error occurred during payment, please try again",
    "APPLE_PAY_TAP_AGAIN": "Please tap Apple Pay again to continue",
    "TITLE": "پرداخت",
    "PAY_CARD": "Checkout",
    "SUCCESSFUL": "Payment Was Successful",
    "SUMMARY": "Payment Summary",
    "PROGRESS": "Payment in progress..., please wait",
    "CANCEL": "Please do not refresh this page or click on the back button. If you wish to cancel, please press the cancel button on the payment machine."
  },
  "ORDER": {
    "TITLE": "My orders",
    "CONFIRMED": "Confirmed",
    "NOTES": "Order Notes",
    "TOTAL": "Total",
    "SUBTOTAL": "Subtotal",
    "ORDER": "Order",
    "PAID": "Paid",
    "PLACED": "Your Order Has Been Placed",
    "UNPAID": "سفارش شما پرداخت نشده است",
    "CANCELLED": "سفارش شما لغو شد",
    "VOID": "سفارش شما باطل شد",
    "UPDATED": "سفارش شما به‌روزرسانی شد",
    "ORDERS": "Orders",
    "PREVIOUS": "Previous Orders",
    "REJECTED": "Oops! One or more items or modifiers are currently unavailable and have been removed from your cart."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "We'll be with you shortly",
    "HELP": "How can we help?",
    "ADDITIONAL_COMMENTS": "Comments"
  },
  "MENU": {
    "SKIP": "رد کردن",
    "MENU": "Menu",
    "SEARCH": "Search",
    "NO_SEARCH_RESULTS": "No items match your search",
    "SEARCH_OTHER_SECTIONS": "We found matches in other sections",
    "NO_FILTER_RESULTS": "No items match your filters",
    "CLEAR_FILTERS": "Clear filters",
    "NO_SECTIONS": "No sections available",
    "STAFF": "Call staff",
    "FILTERS": "Dietery Filters"
  },
  "SETTINGS": {
    "TITLE": "Settings",
    "LANGUAGE": "Language",
    "SELECT_LANGUAGE": "انتخاب زبان",
    "CURRENCY": "Currency"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "Charge to my room"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Please rescan the QR to continue your session",
    "SESSION_EXPIRED": "Your session has expired"
  },
  "PICKUP": {
    "TITLE": "Your Details"
  },
  "VOUCHER": {
    "ADD": "Add a Voucher",
    "PLACEHOLDER": "کد تخفیف خود را وارد کنید",
    "VOUCHER": "Voucher",
    "DISCOUNTED_AMOUNT": "Total After Discount",
    "CURRENT_BALANCE": "Balance",
    "REMAINING_BALANCE": "Balance After Purchase",
    "AMOUNT_DUE": "Amount Due"
  },
  "TIP": {
    "TIP": "انعام",
    "ADD": "افزودن انعام",
    "PLACEHOLDER": "مبلغ انعام را وارد کنید"
  },
  "LANDING": {
    "CALL_WAITER": "صدا زدن گارسون",
    "VIEW_BILL": "مشاهده صورت‌حساب - ",
    "LOADING_BILL": "در حال بارگذاری صورت‌حساب"
  },
  "LOADER": {
    "Heading": "در حال پردازش پرداخت شما...",
    "Subheading": "لطفاً این صفحه را نبندید. در حال تأیید پرداخت شما هستیم و به‌طور خودکار هدایت خواهید شد.",
    "Hint": "این کار معمولاً چند ثانیه طول می‌کشد."
  },
  "NoVoucher": "کد تخفیف موجود نیست",
  "VoucherDisabled": "این کد تخفیف غیرفعال است",
  "VoucherExpired": "این کد تخفیف منقضی شده است",
  "VoucherAlreadyUsed": "این کد تخفیف قبلاً استفاده شده است",
  "VoucherZeroBalance": "موجودی این کد تخفیف 0 است",
  "VoucherUserLimitReached": "شما قبلاً از این کد تخفیف استفاده کرده‌اید",
  "VoucherFirstOrderOnly": "این کد تخفیف فقط برای اولین سفارش شما است",
  "VoucherNotApplicable": "این کد تخفیف به اقلام سفارش شما تعلق ندارد"
}
